import React from 'react';
import AllDiscussionsPanel from './AllDiscussionsPanel';

const DiscussionManager: React.FC = () => {
  return (
    <div className="p-6">
      <AllDiscussionsPanel />
    </div>
  );
};

export default DiscussionManager;
